export default __webpack_public_path__ + "static/media/PublicSans-SemiBold.24c5e716.ttf";